/* eslint-disable react/prop-types */
import React from 'react';
import InfoIcon from '@material-ui/icons/Info';
import { Tooltip } from '@material-ui/core';

const CustomTooltip = ({ text, style = {} }) => (
  <Tooltip title={<span style={{ fontSize: 15 }}>{text}</span>} arrow>
    <div style={{ display: 'flex', alignItems: 'baseline', height: '100%', marginTop: '5px' }}>
      <InfoIcon style={{...style, fill: 'black'}} aria-label="info icon" />
    </div>
  </Tooltip>
);

export default CustomTooltip;
